import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule, Text,
} from '@domain-group/suit-theme'

import useAgencyContact from '@hooks/useAgencyContact'
import useAgencyContacts from '@hooks/useAgencyContacts'

import AgencyContactListItem from './AgencyContactListItem'

const AgencyContacts = (props) => {
  const { agencyId } = props

  const agencyContactPayload = useAgencyContacts({
    filters: { agency_id: agencyId },
    performHttpRequests: !!agencyId,
  })

  const {
    filteredAgencyContacts,
    hasFilteredAgencyContacts,
    loading,
  } = agencyContactPayload

  const {
    callbacks: {
      createOrEditAgencyContact,
    },
  } = useAgencyContact({ agency_id: agencyId })

  return (
    <DashboardModule title="Contacts" loading={loading}>
      <Box flexDirection="column">
        <DashboardModule.ScrollableSection>
          {!loading && hasFilteredAgencyContacts && filteredAgencyContacts.map(agencyContact => (
            <AgencyContactListItem
              agencyContact={agencyContact}
              key={agencyContact.id}
            />
          ))}
        </DashboardModule.ScrollableSection>

        <DashboardModule.Footer boxProps={{ borderTop: hasFilteredAgencyContacts ? '1px solid' : 'none' }}>
          {!loading && !hasFilteredAgencyContacts && (
            <Text
              color="bodyFontLightColor"
              display={['none', 'flex']}
              fontSize="small"
              variant="ellipsis"
              maxWidth="60%"
            >
              Contact Not Set
            </Text>
          )}

          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditAgencyContact()}
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Contact
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

AgencyContacts.propTypes = {
  agencyId: PropTypes.number.isRequired,
}

export default AgencyContacts
